import PropTypes from 'prop-types';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {getAdyenInit} from '../../../actions/adyen/browser';
import {genericErrorHasOccurred} from '../../../actions/generic-error/action-creators';
import propLoaders from '../../../prop-loaders';
import {getErrorStatusCode} from '../../../utils/getErrorStatusCode';
import {
    getLanguageCode,
    getTranslations
} from '../../../utils/selectors';
import {useFetchData} from '../../../utils/useFetchData';
import Spinner from '../../atoms/Spinner';
import {PaymentFormTemplate} from '../../organisms';
import {adyenConfig} from './adyen.config';
import {isPartialData} from './adyen.helpers';
import {useInitializeAdyen, useRedirectWhenPartialData} from './adyen.hooks';

const Adyen = ({
    translations,
    languageCode,
    dispatch,
    initData,
    errorCode: initErrorCode,
    match: {
        params: {
            adyenMethod,
            paymentSessionId
        }
    }
}) => {
    const onError = () => {
        dispatch(genericErrorHasOccurred(true));
    };

    const {data, errorCode} = useFetchData({
        initData,
        initErrorCode,
        fetch: () => getAdyenInit({
            paymentSessionId,
            languageCode
        })
    });

    useEffect(() => {
        if (errorCode) {
            onError();
        }
    }, [errorCode]);

    const onPaymentCompleted = () => {
        window.location.assign(data.returnUrl);
    };

    const checkoutConfiguration = {
        session: data,
        locale: languageCode,
        onPaymentCompleted,
        onError,
        ...adyenConfig,
        showPayButton: true
    };

    useInitializeAdyen(adyenMethod, checkoutConfiguration);
    useRedirectWhenPartialData(data);

    if (!data || isPartialData(data)) {
        return <Spinner styles={{minHeight: 300, height: 'auto'}} />;
    }

    return (
        <PaymentFormTemplate
            translations={translations}
            cancellationUrl={data?.cancelUrl}
            title={translations.adyen[adyenMethod].header}
        >
            <div id="adyen-container" />
        </PaymentFormTemplate>
    );
};

Adyen.getServerSideProps = async ({
    requestId,
    sessionId,
    params: {
        paymentSessionId
    }
}) => {
    try {
        const initData = await propLoaders.getAdyenInit(
            {requestId, sessionId, query: {paymentSessionId}}
        );
        return {
            initData
        };
    } catch (error) {
        return {
            errorCode: getErrorStatusCode(error)
        };
    }
};

Adyen.propTypes = {
    initData: PropTypes.shape({
        cancelUrl: PropTypes.string,
        failureUrl: PropTypes.string,
        id: PropTypes.string,
        returnUrl: PropTypes.string,
        sessionData: PropTypes.string
    }),
    errorCode: PropTypes.number,
    languageCode: PropTypes.string.isRequired,
    translations: PropTypes.shape({}).isRequired
};

Adyen.defaultProps = {
    initData: undefined,
    errorCode: undefined
};

const mapStateToProps = state => ({
    languageCode: getLanguageCode(state),
    translations: getTranslations(state)
});

export default connect(mapStateToProps)(Adyen);
